<script lang="ts">
    import { clickAction } from "$/utils/clickAction";
    import SvgIcon from "../SVGIcon.svelte";

    export let iconName: string = "";
    export let hoverIconName: string = "";
    export let size: number = 16;
    export let height: number = 16;
    export let color: string = "currentColor";
    export let action: Function;
    export let hoverdIconRef: HTMLElement;
    export let strokeWidth: string = "1.5";
</script>

<div class="icon-wrapper relative" use:clickAction={action}>
    <div class="main-icon">
        <SvgIcon name={iconName} {size} {height} {color} {strokeWidth} />
    </div>

    <div class="icon-on-hover" bind:this={hoverdIconRef}>
        <SvgIcon name={hoverIconName} {size} {height} {color} />
    </div>
</div>

<style>
    .main-icon {
        @apply absolute top-0 z-10 h-4 w-4 hover:opacity-0;
    }
    .icon-on-hover {
        @apply h-4 w-4 cursor-pointer opacity-0;
        transition-property: transform;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration: 150ms;
    }

    .main-icon:hover ~ .icon-on-hover {
        @apply opacity-100;
    }
</style>
